import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const FEATURE_LIST_HIDDEN = 'FEATURE_LIST_HIDDEN';
export const FEATURE_LIST_HIDE_FAILED = 'FEATURE_LIST_HIDE_FAILED';

const hideFeatureList = () => (
  (dispatch) => {
    return axios.post('/api/features/hide-feature-list')
      .then(() => {
        dispatch({
          type: FEATURE_LIST_HIDDEN,
        });
      }).catch((error) => {
        dispatch({
          type: FEATURE_LIST_HIDE_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to hide feature list',
          originalError: error,
        }));
      });
  }
);

export default hideFeatureList;
